import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Button from '../Button/Button';
import * as routes from '../../../../constants/routes';
import firebase from '../../../../firebase';

import './Form.css';


class LoginForm extends Component {
    state = {
        name: '',
        email: '',
        errorEmail: false,
        errorEmailAlreadyRegistered: false,
        errorName: false,
        btnLoading: false,
        isBtnActive: false
    };

    
    componentDidMount = () => {
        this.nameInput.focus();
    };

    formIsValid = () => {
        return !this.state.errorEmail && this.state.email && this.state.name;
    };

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
        
        if (e.target.name === 'email') {
            const status = !this.validateEmail(e.target.value);
            this.setState({errorEmail: status});
        }
        
        if (e.target.name === 'name') {
            this.setState({errorName: !this.state.name});
        }

        setTimeout(() => {
            this.setState({
                errorEmailAlreadyRegistered: false
            });

            if (this.formIsValid()) {
                this.setState({isBtnActive: true});
            } else {
                this.setState({isBtnActive: false});
            }
        }, 200);
    };

    validateEmail = (email) => {
        let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };

    handleSubmit = (e) => {
        e.preventDefault();

        this.setState({btnLoading: true});

        // check if email already taken
        firebase.auth().fetchSignInMethodsForEmail(this.state.email)
            .then((methods)=>{
                // if method is empty then email is not already registered
                if(!methods.length){

                    this.props.dataFromForm(this.state.name, this.state.email);

                    this.setState({
                        errorEmailAlreadyRegistered: false
                    });

                    setTimeout(() => {
                        this.props.toNextStep();
                    }, 200);

                } else {
                    // registered email
                    this.setState({
                        errorEmailAlreadyRegistered: true,
                        btnLoading: false
                    });
                }
            })
            .catch((err)=>{
                console.log(err);
                this.setState({
                    btnLoading: false
                });
            });

    };

    render() {
        const {formData} = this.props;
        const {name, email, errorEmail, errorEmailAlreadyRegistered, errorName, isBtnActive, btnLoading} = this.state;

        return (
            <div className="form">
                <h1 className="form__title">{formData.formTitle}</h1>
                <p className="form__desc">The following quiz will help you determine your dosha. You will then receive a body type report with practical Ayurvedic tips. Start by entering your name and email below.</p>
                <form action="" className="form__wrapper">
                   <div className="form__input-area">
                       <label htmlFor="name" className="form__label">First name</label>
                       <input
                           type="text"
                           id="name"
                           name="name"
                           className={'form__input' + (errorName ? ' input-error' : '')}
                           placeholder="e.g. John"
                           ref={(name) => { this.nameInput = name; }}
                           value={name}
                           onChange={this.handleChange}
                           onBlur={this.handleChange}
                       />
                   </div>
                    <div className="form__input-area">
                        <label htmlFor="email" className="form__label">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            className={'form__input' + (errorEmail ? ' input-error' : '')}
                            placeholder="your@email.com"
                            value={email}
                            onChange={this.handleChange}
                            onBlur={this.handleChange}
                        />
                    </div>

                    {errorEmailAlreadyRegistered &&
                        <div className="clear">
                            <p className="error__message">* Email address already registered!</p>
                        </div>
                    }

                    <Button
                        toNextStep={this.handleSubmit} 
                        buttonData={formData.button} 
                        disabled={!isBtnActive}
                        loading={btnLoading}
                    />
                </form>
                <p className="form__additional">
                    Already have an account? <Link to={routes.SIGN_IN}>Sign in now</Link>
                </p>
            </div>
        )
    }

}

LoginForm.propTypes = {
    formData: PropTypes.shape({
        formTitle: PropTypes.string,
        isLogin: PropTypes.bool.isRequired,
        button: PropTypes.object.isRequired
    }),
    answers: PropTypes.array.isRequired
};

export default LoginForm;


// WEBPACK FOOTER //
// ./src/components/Quiz/QuizDetails/Form/LoginForm.js